import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useDeleteReturnReason(shop: ShopDto) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateShop = useInvalidateShop(shop.id);
	const mutation = $api.useMutation(
		"delete",
		"/shops/{shopId}/reasons/{reasonId}",
	);

	return useMutation({
		onSuccess: () => {
			invalidateShop();
			successNotification();
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async (reasonId: string) => {
			await mutation.mutateAsync({
				params: { path: { shopId: shop?.id, reasonId } },
			});
		},
	});
}
